/**
 * Returns the app's base URL.
 * In production the explicit env var is used; in preview deploys (where the URL
 * isn't known at build time) it falls back to window.location.origin.
 */
export const getBaseUrl = () =>
  import.meta.env.VITE_APP_BASE_URL || `${window.location.origin}/`;
